export default __webpack_public_path__ + "static/media/m_ceoLanding03.2782702b.png";